// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';

Vue.use(ElementUI);

// 引入打印图片的插件
import Print from "vue-print-nb"
Vue.use(Print)

// 引入vue高德地图插件
import VueAMap from 'vue-amap';
Vue.use(VueAMap);
VueAMap.initAMapApiLoader({
  key: '1c4dfbe6c1796c98b590165805aff1ab', // 自己申请的key值
  plugin: [
    'AMap.Autocomplete',// 输入提示插件
    'AMap.PlaceSearch',// POI搜索插件
    'AMap.Scale',// 右下角缩略图插件 比例尺
    'AMap.OverView',// 地图鹰眼插件
    'AMap.ToolBar',// 地图工具条
    'AMap.MapType',
    "AMap.Marker",
    "AMap.Geolocation"// 定位控件，用来获取和展示用户主机所在的经纬度位置
  ],
  v: '1.4.4'
});
window._AMapSecurityConfig = {
  securityJsCode: 'b4afad4923644f1c3a3a3566781fa4aa',
}

import requestApi from './api/requestApi'
Vue.prototype.$http = requestApi;

Vue.config.productionTip = false;

router.beforeEach((to, from, next) => {
  const tokenStr = window.sessionStorage.getItem("Token");
  if (to.path == '/login' || to.path == '/' || tokenStr) {
    next()
  } else {
    next('/login')
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js